<ui-breadcrumb-nav [ariaLabel]="'cockpit.parseRequests.details.breadcrumb.ariaLabel' | transloco">
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId()]">
      <ng-icon name="heroHome" size="20" class="!block" />
      <span class="sr-only">
        {{ 'cockpit.parseRequests.details.breadcrumb.dashboard' | transloco }}
      </span>
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId(), 'supplier-contracts']">
      {{ 'cockpit.parseRequests.details.breadcrumb.contracts' | transloco }}
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a
      [routerLink]="['/organizations', organizationId(), 'parse-requests', parseRequestId()]"
      aria-current="page"
    >
      {{ 'cockpit.parseRequests.details.breadcrumb.contractDetails' | transloco }}
    </a>
  </ui-breadcrumb>
</ui-breadcrumb-nav>
